import React, { createContext, useContext, useMemo, useState } from 'react';

const translations = {
  vi: {
    nav: {
      rooms: 'Phòng trọ',
      dashboard: 'Dashboard',
      myRooms: 'Phòng của tôi',
      createRoom: 'Đăng phòng',
      bookings: 'Đặt phòng',
      users: 'Người dùng',
      profile: 'Hồ sơ',
      logout: 'Đăng xuất',
      login: 'Đăng nhập',
      register: 'Đăng ký',
      toggleTheme: 'Đổi giao diện sáng tối',
      toggleMenu: 'Mở hoặc đóng menu',
    },
    common: {
      close: 'Đóng',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      loading: 'Đang tải...',
      understood: 'Đã hiểu',
      languageVi: 'Tiếng Việt',
      languageEn: 'English',
    },
    auth: {
      loginTitle: 'Đăng nhập',
      registerTitle: 'Đăng ký tài khoản',
      email: 'Email',
      password: 'Mật khẩu',
      confirmPassword: 'Xác nhận mật khẩu',
      fullName: 'Họ và tên',
      phone: 'Số điện thoại',
      loginButton: 'Đăng nhập',
      loggingIn: 'Đang đăng nhập...',
      registerButton: 'Đăng ký',
      sendingCode: 'Đang gửi mã xác nhận...',
      verifyAndCreate: 'Xác nhận và tạo tài khoản',
      verifying: 'Đang xác minh...',
      noAccount: 'Chưa có tài khoản?',
      registerNow: 'Đăng ký ngay',
      haveAccount: 'Đã có tài khoản?',
      loginNow: 'Đăng nhập',
      verifyEmail: 'Email xác nhận',
      verifyCodeLabel: 'Nhập mã 6 số',
      verifyCodePlaceholder: 'Ví dụ: 123456',
      resendCode: 'Gửi lại mã',
      resendingCode: 'Đang gửi lại mã...',
      backToEdit: 'Quay lại chỉnh sửa thông tin',
      mismatchPassword: 'Mật khẩu xác nhận không khớp',
      loginFailed: 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.',
      registerFailed: 'Đăng ký thất bại. Vui lòng thử lại.',
      verifyFailed: 'Xác minh thất bại. Vui lòng kiểm tra lại mã.',
      resendFailed: 'Không thể gửi lại mã xác nhận.',
      invalidCredentials: 'Thông tin đăng nhập không chính xác.',
      invalidData: 'Dữ liệu chưa hợp lệ. Vui lòng kiểm tra lại.',
      sessionExpired: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
      forbidden: 'Bạn không có quyền thực hiện thao tác này.',
      requestFailed: 'Không thể thực hiện yêu cầu. Vui lòng thử lại.',
      roleRejectedTitle: 'Yêu cầu nâng quyền đã bị từ chối',
      roleApprovedTitle: 'Chúc mừng bạn đã được duyệt',
      roleRejectedBody: 'Yêu cầu đăng ký lên chủ trọ/môi giới của bạn đã bị từ chối.',
      roleApprovedBody: 'Yêu cầu đăng ký lên chủ trọ/môi giới của bạn đã được duyệt thành công.',
      adminReason: 'Lý do từ admin',
      adminNote: 'Ghi chú từ admin',
    },
    roles: {
      admin: 'Quản trị viên',
      landlord: 'Chủ trọ',
      saler: 'Saler',
      user: 'Người thuê',
    },
    dashboard: {
      greeting: 'Xin chào',
      role: 'Vai trò',
      myRooms: 'Phòng trọ của tôi',
      bookings: 'Đặt phòng',
      manageUsers: 'Quản lý người dùng',
      viewAll: 'Xem tất cả',
      manage: 'Quản lý',
      recentBookings: 'Đặt phòng gần đây',
      noBookings: 'Chưa có đặt phòng nào',
      quickLinks: 'Liên kết nhanh',
      findRooms: 'Tìm phòng trọ',
      createRoom: 'Đăng phòng mới',
      profile: 'Hồ sơ cá nhân',
      room: 'Phòng',
      booker: 'Người đặt',
      startDate: 'Ngày bắt đầu',
      status: 'Trạng thái',
      statusPending: 'Chờ duyệt',
      statusApproved: 'Đã duyệt',
      statusRejected: 'Từ chối',
      statusCancelled: 'Đã hủy',
      statusCompleted: 'Hoàn thành',
      dbInfo: 'Database thông tin',
      usingDb: 'Đang sử dụng database',
      onHost: 'trên host',
      environment: 'Environment',
      pendingRequests: 'yêu cầu đăng ký chủ trọ/môi giới đang chờ duyệt.',
      handleNow: 'Xử lý ngay',
    },
    roomList: {
      sortLatest: 'Mới nhất',
      sortOldest: 'Cũ nhất',
      sortPriceAsc: 'Giá: Thấp → Cao',
      sortPriceDesc: 'Giá: Cao → Thấp',
      sortCapacityAsc: 'Sức chứa: Ít → Nhiều',
      sortCapacityDesc: 'Sức chứa: Nhiều → Ít',
      amenityWifi: 'WiFi',
      amenityAc: 'Điều hòa',
      amenityKitchen: 'Bếp',
      amenityParking: 'Chỗ đỗ xe',
      amenityWater: 'Nước nóng',
      amenitySecurity: 'An ninh 24/7',
      loadFailed: 'Không tải được danh sách phòng. Vui lòng thử lại.',
      heroTitle: 'Khám phá phòng trọ theo nhu cầu thực tế',
      loadingRooms: 'Đang tải dữ liệu phòng trọ...',
      heroSubtitle: 'Tập trung vào vị trí, mức giá và khả năng ở để bạn chọn phòng nhanh, đúng nhu cầu.',
      statShowing: 'Phòng đang hiển thị',
      statAvgPrice: 'Giá trung bình / tháng',
      statAvailable: 'Phòng còn trống',
      viewMode: 'Chế độ hiển thị phòng',
      activeFilters: 'Bộ lọc đang bật',
      sortBy: 'Sắp xếp:',
      sortAria: 'Sắp xếp phòng',
      viewGrid: 'Hiển thị dạng lưới',
      viewList: 'Hiển thị dạng danh sách',
      viewMap: 'Hiển thị dạng bản đồ',
      viewAllRooms: 'Xem tất cả phòng',
      viewFavoriteRooms: 'Xem phòng yêu thích',
      enableInfiniteScroll: 'Bật cuộn vô hạn',
      disableInfiniteScroll: 'Tắt cuộn vô hạn',
      infiniteOn: 'Cuộn vô hạn: Bật',
      infiniteOff: 'Cuộn vô hạn: Tắt',
      favorites: 'Yêu thích',
      searchPlaceholder: 'Tìm kiếm...',
      searchAgain: 'Tìm lại',
      searchByTitle: 'Tìm theo tên phòng',
      openFilters: 'Mở bộ lọc',
      closeFilters: 'Đóng bộ lọc',
      openSettings: 'Mở cài đặt hiển thị',
      products: 'Sản phẩm',
      projects: 'Dự án',
      statistics: 'Thống kê',
      map: 'Bản đồ',
      favoriteFilters: 'Bộ lọc yêu thích',
      noFavoriteFilters: 'Chưa có bộ lọc đã lưu',
      recentSearches: 'Tìm kiếm gần đây',
      city: 'Thành phố',
      district: 'Quận / Huyện',
      ward: 'Phường / Xã',
      street: 'Đường',
      filterByCity: 'Lọc theo thành phố',
      minPrice: 'Giá tối thiểu',
      maxPrice: 'Giá tối đa',
      minCommission: 'Hoa hồng tối thiểu (%)',
      maxCommission: 'Hoa hồng tối đa (%)',
      roomType: 'Loại phòng',
      allRoomTypes: 'Tất cả loại phòng',
      furnishing: 'Nội thất',
      allFurnishing: 'Tất cả nội thất',
      typeRoom: 'Gác',
      typeGac: 'Gác',
      typeStudio: 'Studio',
      typeDuplex: 'Duplex',
      typeStudioSeparate: 'Studio tách bếp',
      typeOneBedroom: '1PN',
      typeTwoBedroom: '2PN',
      typeThreeBedroom: '3PN',
      typeApartment: 'Chung cư',
      typeWholeHouse: 'Nhà nguyên căn',
      typeCommercial: 'Mặt bằng',
      furnishingFull: 'Full nội thất',
      furnishingBasic: 'Nội thất cơ bản',
      furnishingEmpty: 'Nội thất trống',
      statusAndOffers: 'Trạng thái & ưu đãi',
      statusSoonAvailable: 'Sắp trống',
      statusTransfer: 'Nhượng',
      statusClosed: 'Đã chốt',
      statusReserved: 'Cọc / Giữ chỗ',
      hotOffer: 'Thưởng nóng',
      exclusiveOffer: 'Độc quyền',
      amenities: 'Tiện ích:',
      applyFilters: 'Áp dụng bộ lọc tìm kiếm',
      search: 'Tìm kiếm',
      clearFilters: 'Xóa bộ lọc',
      noResults: 'Không có kết quả',
      results: 'kết quả',
      clearSearchFilter: 'Xóa bộ lọc tìm kiếm',
      clearCityFilter: 'Xóa bộ lọc thành phố',
      clearMinPriceFilter: 'Xóa bộ lọc giá tối thiểu',
      clearMaxPriceFilter: 'Xóa bộ lọc giá tối đa',
      minPricePrefix: 'Tối thiểu',
      maxPricePrefix: 'Tối đa',
      clearAmenity: 'Xóa tiện ích',
      disableFavoriteFilter: 'Tắt lọc phòng yêu thích',
      noFavoriteRooms: 'Chưa có phòng yêu thích',
      noRoomsFound: 'Không tìm thấy phòng trọ nào',
      noFavoriteRoomsHint: 'Bắt đầu thêm phòng yêu thích bằng cách nhấn nút trái tim trên các phòng.',
      noRoomsFoundHint: 'Hãy thử thay đổi bộ lọc hoặc tìm kiếm lại với các tiêu chí khác.',
      clearFiltersAndRetry: 'Xóa bộ lọc và tìm lại',
      loginForMore: 'Đăng nhập để xem thêm tùy chọn',
      statusAvailable: 'Còn trống',
      statusRented: 'Đã thuê',
      statusMaintenance: 'Bảo trì',
      detail: 'Chi tiết',
      directions: 'Chỉ đường',
      area: 'Diện tích',
      capacity: 'Sức chứa',
      person: 'người',
      prevImage: 'Xem ảnh trước',
      nextImage: 'Xem ảnh tiếp theo',
      addFavoriteAria: 'Thêm {title} vào yêu thích',
      removeFavoriteAria: 'Xóa {title} khỏi yêu thích',
      currencyShort: 'đ',
      perMonth: 'tháng',
      viewRoomDetail: 'Xem chi tiết phòng',
      viewDetail: 'Xem chi tiết',
      prevPage: 'Trang trước',
      nextPage: 'Trang sau',
      page: 'Trang',
      loadMoreRooms: 'Tải thêm phòng',
      loadMore: 'Tải thêm',
    },
    home: {
      heroTitle: 'Nền tảng cho thuê trọ minh bạch, dễ vận hành và sẵn sàng mở rộng quy mô',
      heroSubtitle: 'Từ tìm kiếm phòng theo khu vực, giá, tiện ích cho đến quản lý booking và chủ trọ trên cùng một hệ thống, trải nghiệm mượt trên cả desktop và mobile.',
      ctaExploreRooms: 'Khám phá phòng trọ',
      ctaStartPosting: 'Bắt đầu đăng tin',
      ctaGoDashboard: 'Vào bảng điều khiển',
      statUptime: 'Hệ thống hoạt động liên tục',
      statOnePlatformTitle: '1 nền tảng',
      statOnePlatformDesc: 'Cho người thuê, chủ trọ, admin',
      statRealtime: 'Cập nhật trạng thái booking',
      statScalable: 'Phù hợp phát triển dự án lớn',
      featureTitle: 'Tính năng trọng tâm',
      featureSubtitle: 'Tập trung vào trải nghiệm sử dụng thực tế trong ngành cho thuê trọ.',
      featureSearchTitle: 'Tìm phòng theo nhu cầu',
      featureSearchDesc: 'Bộ lọc theo thành phố, mức giá, tình trạng phòng giúp người thuê ra quyết định nhanh hơn.',
      featureManageTitle: 'Quản lý tin đăng tập trung',
      featureManageDesc: 'Chủ trọ và môi giới theo dõi phòng đã đăng, tình trạng còn trống, lịch sử giao dịch trong một nơi.',
      featureDashboardTitle: 'Dashboard vận hành rõ ràng',
      featureDashboardDesc: 'Theo dõi booking, người dùng, phòng trọ bằng giao diện trực quan để vận hành ở quy mô lớn.',
    },
    myRooms: {
      title: 'Phòng trọ của tôi',
      createNew: 'Đăng phòng mới',
      createFirst: 'Đăng phòng đầu tiên',
      emptyTitle: 'Bạn chưa đăng phòng nào',
      emptyDescription: 'Bắt đầu kiếm doanh thu ngay bằng cách đăng phòng của bạn lên nền tảng.',
      colTitle: 'Tiêu đề',
      colAddress: 'Địa chỉ',
      colPrice: 'Giá',
      colStatus: 'Trạng thái',
      colActions: 'Hành động',
      statusAvailable: 'Còn trống',
      statusRented: 'Đã cho thuê',
      statusMaintenance: 'Bảo trì',
      view: 'Xem',
      edit: 'Sửa',
      delete: 'Xóa',
      viewAria: 'Xem chi tiết phòng {title}',
      editAria: 'Sửa phòng {title}',
      deleteAria: 'Xóa phòng {title}',
      confirmDelete: 'Bạn có chắc chắn muốn xóa phòng này?',
      deleteFailed: 'Xóa phòng thất bại',
      copyId: 'Sao chép ID phòng',
      quickStatus: 'Đổi nhanh trạng thái phòng',
      activateRoom: 'Bật: còn phòng và hiển thị công khai',
      deactivateRoom: 'Tắt: hết phòng và ẩn khỏi danh sách công khai',
      updatingStatus: 'Đang lưu...',
      roomActivated: 'Phòng còn trống và đã được hiển thị công khai.',
      roomHidden: 'Đã chuyển sang hết phòng và ẩn khỏi danh sách công khai.',
      statusUpdateFailed: 'Không thể đổi trạng thái phòng. Vui lòng thử lại.',
      idCopied: 'Đã sao chép ID phòng',
      copyIdFailed: 'Không thể sao chép. Vui lòng chọn mã phòng và sao chép thủ công.',
      currencyShort: 'đ',
    },
    bookingList: {
      title: 'Danh sách đặt phòng',
      updateFailed: 'Cập nhật trạng thái thất bại',
      confirmCancel: 'Bạn có chắc muốn xóa phiếu cọc này? Phiếu sẽ bị xóa khỏi hệ thống.',
      cancelTitle: 'Xóa phiếu cọc',
      draftDeleteTitle: 'Xóa bản nháp',
      draftDeleteMessage: 'Bạn có chắc muốn xóa bản nháp phiếu cọc này? Thông tin và ảnh trong bản nháp sẽ bị xóa.',
      draftDelete: 'Xóa bản nháp',
      draftKeep: 'Giữ lại',
      edit: 'Chỉnh sửa',
      openingEditor: 'Đang mở…',
      editFailed: 'Không mở được phiếu cọc để chỉnh sửa. Vui lòng thử lại.',
      deleteFailed: 'Xóa đặt phòng thất bại',
      statusPending: 'Chờ duyệt',
      statusApproved: 'Đã duyệt',
      statusRejected: 'Từ chối',
      statusCancelled: 'Đã hủy',
      statusCompleted: 'Hoàn thành',
      infoLabel: 'Thông tin',
      emptyTitle: 'Không có đặt phòng nào',
      emptyManager: 'Hiện chưa có yêu cầu đặt phòng. Các yêu cầu sẽ xuất hiện tại đây.',
      emptyUser: 'Bạn chưa đặt phòng nào. Hãy khám phá các phòng trọ có sẵn.',
      colRoom: 'Phòng',
      colBooker: 'Người đặt',
      colStartDate: 'Ngày bắt đầu',
      colPrice: 'Giá',
      colStatus: 'Trạng thái',
      colActions: 'Hành động',
      approve: 'Duyệt',
      reject: 'Từ chối',
      complete: 'Hoàn thành',
      cancel: 'Xóa phiếu',
      viewForm: 'Xem form',
      approveAria: 'Duyệt đặt phòng {id}',
      rejectAria: 'Từ chối đặt phòng {id}',
      completeAria: 'Hoàn thành đặt phòng {id}',
      cancelAria: 'Xóa phiếu cọc {id}',
      viewFormAria: 'Xem form khách gửi cho đơn {id}',
      modalTitle: 'Thông tin khách gửi',
      closeModal: 'Đóng thông tin đặt phòng',
      orderLabel: 'Đơn',
      roomLabel: 'Phòng',
      bookerLabel: 'Người đặt',
      currencyShort: 'đ',
    },
    createRoom: {
      title: 'Đăng phòng trọ mới',
      maxImagesError: 'Chỉ được chọn tối đa {max} ảnh.',
      maxImageSizeError: 'Mỗi ảnh tối đa {size}MB.',
      readImageFailed: 'Đọc ảnh thất bại. Vui lòng chọn lại ảnh.',
      createSuccessWithId: 'Đăng phòng thành công: {title} (ID: {id})',
      createSuccess: 'Đăng phòng thành công.',
      invalidData: 'Dữ liệu chưa hợp lệ. Vui lòng kiểm tra lại.',
      sessionExpired: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
      noPermission: 'Bạn không có quyền đăng phòng.',
      imageTooLarge: 'Dung lượng ảnh quá lớn. Vui lòng giảm kích thước ảnh.',
      createFailed: 'Tạo phòng thất bại. Vui lòng thử lại.',
      fieldTitle: 'Tiêu đề',
      fieldDescription: 'Mô tả',
      fieldAddress: 'Địa chỉ',
      fieldDistrict: 'Quận/Huyện',
      fieldCity: 'Thành phố',
      mapTitle: 'Chọn vị trí phòng trên bản đồ',
      mapHint: 'Bấm trực tiếp lên bản đồ để đặt pin. Kéo pin để chỉnh lại vị trí chính xác hơn.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      notSelected: 'Chưa chọn',
      fieldPrice: 'Giá ({currency}/{period})',
      perMonth: 'tháng',
      fieldArea: 'Diện tích phòng (m²)',
      fieldCapacity: 'Sức chứa (người)',
      fieldUtilities: 'Tiện ích (phân cách bằng dấu phẩy)',
      utilitiesPlaceholder: 'Ví dụ: Wifi, Máy lạnh, Tủ lạnh, Máy giặt',
      fieldImages: 'Hình ảnh phòng (tối đa {max} ảnh, mỗi ảnh <= {size}MB)',
      selectedCount: 'Đã chọn: {count} ảnh',
      removeSelectedImageAria: 'Xóa ảnh đã chọn {index}',
      creating: 'Đang tạo...',
      submit: 'Đăng phòng',
    },
    editRoom: {
      title: 'Chỉnh sửa phòng trọ',
      loadFailed: 'Không thể tải thông tin phòng',
      maxImagesExceeded: 'Chỉ được chọn tối đa {max} ảnh.',
      imageSizeLimitExceeded: 'Mỗi ảnh tối đa {size}MB.',
      readImageFailed: 'Đọc ảnh thất bại. Vui lòng chọn lại ảnh.',
      invalidData: 'Dữ liệu chưa hợp lệ. Vui lòng kiểm tra lại.',
      updateSuccess: 'Cập nhật phòng thành công.',
      updateFailed: 'Cập nhật phòng thất bại. Vui lòng thử lại.',
      sessionExpired: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
      noPermission: 'Bạn không có quyền chỉnh sửa phòng này.',
      fieldTitle: 'Tiêu đề',
      fieldDescription: 'Mô tả',
      fieldAddress: 'Địa chỉ',
      fieldDistrict: 'Quận/Huyện',
      fieldCity: 'Thành phố',
      mapTitle: 'Chọn vị trí phòng trên bản đồ',
      mapHint: 'Bấm trực tiếp lên bản đồ để đặt pin. Kéo pin để chỉnh lại vị trí chính xác hơn.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      notSelected: 'Chưa chọn',
      fieldPrice: 'Giá ({currency}/{period})',
      perMonth: 'tháng',
      fieldArea: 'Diện tích phòng (m²)',
      fieldCapacity: 'Sức chứa (người)',
      fieldStatus: 'Trạng thái',
      statusAvailable: 'Còn trống',
      statusRented: 'Đã cho thuê',
      statusMaintenance: 'Bảo trì',
      fieldUtilities: 'Tiện ích (phân cách bằng dấu phẩy)',
      utilitiesPlaceholder: 'Ví dụ: Wifi, Máy lạnh, Tủ lạnh, Máy giặt',
      existingImages: 'Hình ảnh hiện tại',
      roomImageAlt: 'Ảnh phòng số {index}',
      noImages: 'Chưa có ảnh nào',
      addNewImages: 'Thêm ảnh mới (tối đa {max} ảnh, mỗi ảnh <= {size}MB)',
      newImageAlt: 'Ảnh phòng mới số {index}',
      updating: 'Đang cập nhật...',
      submit: 'Cập nhật',
    },
    roomDetail: {
      title: 'Chi tiết phòng trọ',
      loading: 'Đang tải...',
      notFound: 'Không tìm thấy phòng trọ',
      back: '← Quay lại',
      statusAvailable: 'Còn trống',
      statusRented: 'Đã cho thuê',
      statusMaintenance: 'Bảo trì',
      share: 'Chia sẻ',
      copyLink: 'Copy link',
      shareSuccessMessage: 'Đã sao chép link chia sẻ.',
      shareErrorMessage: 'Không thể chia sẻ lúc này.',
      copiedMessage: 'Đã sao chép.',
      copyErrorMessage: 'Không thể sao chép lúc này.',
      shareAria: 'Chia sẻ phòng',
      copyLinkAria: 'Sao chép link phòng',
      areaLabel: 'Diện tích phòng',
      capacityLabel: 'Sức chứa',
      person: 'người',
      addressLabel: 'Địa chỉ',
      prevImageAria: 'Xem ảnh trước',
      nextImageAria: 'Xem ảnh tiếp theo',
      noImages: 'Chưa có ảnh cho phòng này',
      scrollLeftAria: 'Cuộn ảnh thu nhỏ sang trái',
      scrollRightAria: 'Cuộn ảnh thu nhỏ sang phải',
      selectImageAria: 'Chọn ảnh {index}',
      detailDescription: 'Mô tả chi tiết',
      detailAddress: 'Địa chỉ',
      detailAddressValue: 'Địa chỉ:',
      detailWard: 'Phường/Xã:',
      detailDistrict: 'Quận/Huyện:',
      detailCity: 'Thành phố:',
      roomInformation: 'Thông tin phòng',
      roomType: 'Loại phòng',
      furnishing: 'Nội thất',
      notAvailable: 'Chưa cập nhật',
      fees: 'Phí dịch vụ',
      electricity: 'Tiền điện',
      water: 'Tiền nước',
      parking: 'Phí gửi xe',
      serviceFee: 'Phí dịch vụ',
      otherFee: 'Phí khác',
      policies: 'Chính sách & Quy định',
      depositMonths: 'Tiền cọc',
      reservationFee: 'Cọc giữ chỗ',
      additionalDeposit: 'Cần bổ sung',
      contractMonths: 'Thời hạn hợp đồng',
      holdDays: 'Thời gian giữ phòng',
      maxVehicles: 'Số xe tối đa',
      pets: 'Thú cưng',
      foreignGuests: 'Khách nước ngoài',
      mapLocation: 'Vị trí trên bản đồ',
      directions: 'Chỉ đường',
      coordinates: 'Tọa độ:',
      utilities: 'Tiện ích',
      currencySymbol: 'đ/tháng',
      ownerInfo: 'Thông tin chủ nhà',
      ownerName: 'Tên:',
      ownerPhone: 'Số điện thoại:',
      phoneNotUpdated: 'Chưa cập nhật',
      callNow: 'Gọi ngay',
      copyNumber: 'Copy số',
      sendZalo: 'Nhắn Zalo',
      openMessenger: 'Mở Messenger',
      openFacebook: 'Facebook',
      qrTitle: 'QR Zalo',
      bookingTitle: 'Đặt phòng',
      bookingLoginMessage: 'Vui lòng đăng nhập để đặt phòng',
      bookingLogin: 'Đăng nhập',
      bookingRegisterHint: 'Chưa có tài khoản?',
      bookingRegisterLink: 'Đăng ký ngay',
      bookingButton: 'Đặt phòng ngay',
      bookingModalTitle: 'Thông tin đặt phòng',
      bookingModalClose: 'Đóng form đặt phòng',
      bookingStartDate: 'Ngày bắt đầu đặt',
      bookingMonths: 'Số tháng thuê',
      bookingEndDate: 'Ngày kết thúc tự động',
      bookingEndDateAuto: 'Tự động tính',
      bookingFullName: 'Họ tên',
      bookingPhone: 'Số điện thoại',
      bookingAddress: 'Thường trú',
      bookingCCCD: 'CCCD',
      bookingPeople: 'Số người',
      bookingVehicles: 'Số xe',
      bookingNotes: 'Ghi chú',
      bookingNotesPlaceholder: 'Thêm ghi chú nếu có...',
      bookingSubmit: 'Hoàn tất',
      bookingRequired: 'Vui lòng nhập đầy đủ thông tin bắt buộc.',
      bookingInvalidPeople: 'Số người phải từ 1 trở lên.',
      bookingInvalidVehicles: 'Số xe không hợp lệ.',
      bookingInvalidMonths: 'Số tháng thuê phải từ 1 đến 120.',
      bookingInvalidDate: 'Ngày bắt đầu không hợp lệ.',
      bookingPastDate: 'Ngày bắt đầu phải từ hôm nay trở đi.',
      bookingSuccess: 'Đặt phòng thành công! Vui lòng chờ phê duyệt.',
      bookingFailed: 'Đặt phòng thất bại. Vui lòng thử lại.',
      edit: 'Chỉnh sửa',
      buildingNotesStartDate: 'Ngay bat dau',
      buildingNotesMonths: 'So thang thue',
      buildingNotesEndDate: 'Ngay ket thuc',
      buildingNotesFullName: 'Ho ten',
      buildingNotesPhone: 'So dien thoai',
      buildingNotesAddress: 'Thuong tru',
      buildingNotesCCCD: 'CCCD',
      buildingNotesPeople: 'So nguoi',
      buildingNotesVehicles: 'So xe',
      buildingNotesNotes: 'Ghi chu',
    },
    userList: {
      title: 'Quản lý người dùng',
      noUsers: 'Không có người dùng nào',
        notAvailable: 'Không có',
      onlyAdmin: 'Bạn là quản trị viên duy nhất hiện tại trong hệ thống.',
      requestsTitle: 'Yêu cầu đăng ký chủ trọ/môi giới',
      noRequests: 'Không có yêu cầu nào.',
      id: 'ID',
      name: 'Tên',
      email: 'Email',
      role: 'Vai trò',
      phone: 'Số điện thoại',
      createdAt: 'Ngày tạo',
      actions: 'Hành động',
      identifier: 'Định danh',
      userNote: 'Ghi chú user',
      status: 'Trạng thái',
      approve: 'Duyệt',
      reject: 'Từ chối',
      processed: 'Đã xử lý',
      notUpdated: 'Chưa cập nhật',
      delete: 'Xóa',
        deleteUserAria: 'Xóa người dùng {name}',
      grantSaler: 'Cấp quyền chủ trọ',
      revokeSaler: 'Gỡ quyền chủ trọ',
      confirmDeleteTitle: 'Xác nhận xóa tài khoản',
      confirmRoleTitle: 'Xác nhận cập nhật vai trò',
      confirmRoleChange: 'Chuyển tài khoản {name} sang vai trò {role}?',
      roleFor: 'Vai trò của {name}',
      confirmDeleteMessage: 'Bạn có chắc chắn muốn xóa tài khoản {name}?',
      confirmGrantRole: 'Bạn có chắc muốn cấp quyền Chủ nhà / Môi giới cho {name}?',
      confirmRevokeRole: 'Bạn có chắc muốn thu hồi quyền Chủ nhà / Môi giới (về Người thuê) cho {name}?',
      deleteSuccess: 'Đã xóa tài khoản thành công.',
      updateRoleSuccess: 'Đã cập nhật vai trò người dùng thành công.',
      actionFailed: 'Không thể thực hiện thao tác.',
      reviewFailed: 'Xử lý yêu cầu thất bại.',
      approvedSuccess: 'Đã duyệt yêu cầu.',
      rejectedSuccess: 'Đã từ chối yêu cầu.',
      approveNote: 'Ghi chú duyệt (không bắt buộc)',
      rejectNote: 'Lý do từ chối (không bắt buộc)',
      inputNote: 'Nhập ghi chú...',
      approveRequest: 'Duyệt yêu cầu',
      rejectRequest: 'Xác nhận từ chối',
      pending: 'Chờ duyệt',
      approved: 'Đã duyệt',
      rejected: 'Từ chối',
    },
    profile: {
      userCode: 'Mã người dùng',
      userCodePending: 'Được cấp khi duyệt nâng cấp tài khoản',
      userCodeHint: 'Mã được cấp tự động, cố định và không thể chỉnh sửa.',
      title: 'Hồ sơ cá nhân',
      updateSuccess: 'Cập nhật hồ sơ thành công!',
      updateFailed: 'Cập nhật thất bại. Vui lòng thử lại.',
      role: 'Vai trò',
      address: 'Địa chỉ',
      changePassword: 'Đổi mật khẩu',
      leaveEmpty: 'Để lại trống nếu không muốn đổi mật khẩu',
      newPassword: 'Mật khẩu mới',
      confirmNewPassword: 'Xác nhận mật khẩu mới',
      updateProfile: 'Cập nhật hồ sơ',
      updating: 'Đang cập nhật...',
      ownerRegisterTitle: 'Đăng ký chủ trọ / môi giới',
      ownerRegisterButton: 'Đăng ký chủ trọ / môi giới',
      ownerRegisterClose: 'Đóng form đăng ký',
      ownerPending: 'Bạn đã có yêu cầu đang chờ duyệt, tạm thời chưa thể gửi thêm.',
      ownerHint: 'Điền thông tin để quản trị viên xét duyệt. Khi được duyệt, tài khoản sẽ được nâng thành chủ trọ/môi giới.',
      companyName: 'Tên đơn vị / thương hiệu (nếu có)',
      idNumber: 'CCCD/CMND hoặc mã định danh',
      expYears: 'Số năm kinh nghiệm',
      propertyCount: 'Số lượng phòng/bất động sản đang quản lý',
      extraInfo: 'Mô tả thêm',
      extraInfoPlaceholder: 'Ví dụ: khu vực đang quản lý, thời gian hoạt động...',
      submitRequest: 'Gửi yêu cầu xét duyệt',
      submittingRequest: 'Đang gửi yêu cầu...',
      requestFailed: 'Không thể gửi yêu cầu. Vui lòng thử lại.',
      requestSent: 'Đã gửi yêu cầu đăng ký chủ trọ/môi giới.',
    },
  },
  en: {
    nav: {
      rooms: 'Rooms',
      dashboard: 'Dashboard',
      myRooms: 'My Rooms',
      createRoom: 'Post Room',
      bookings: 'Bookings',
      users: 'Users',
      profile: 'Profile',
      logout: 'Logout',
      login: 'Login',
      register: 'Register',
      toggleTheme: 'Toggle light/dark theme',
      toggleMenu: 'Open or close menu',
    },
    common: {
      close: 'Close',
      cancel: 'Cancel',
      confirm: 'Confirm',
      loading: 'Loading...',
      understood: 'Got it',
      languageVi: 'Vietnamese',
      languageEn: 'English',
    },
    auth: {
      loginTitle: 'Login',
      registerTitle: 'Create Account',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      phone: 'Phone Number',
      loginButton: 'Login',
      loggingIn: 'Logging in...',
      registerButton: 'Register',
      sendingCode: 'Sending verification code...',
      verifyAndCreate: 'Verify and Create Account',
      verifying: 'Verifying...',
      noAccount: "Don't have an account?",
      registerNow: 'Register now',
      haveAccount: 'Already have an account?',
      loginNow: 'Login',
      verifyEmail: 'Verification Email',
      verifyCodeLabel: 'Enter 6-digit code',
      verifyCodePlaceholder: 'Example: 123456',
      resendCode: 'Resend code',
      resendingCode: 'Resending code...',
      backToEdit: 'Back to edit information',
      mismatchPassword: 'Password confirmation does not match',
      loginFailed: 'Login failed. Please check your credentials.',
      registerFailed: 'Registration failed. Please try again.',
      verifyFailed: 'Verification failed. Please check the code.',
      resendFailed: 'Unable to resend verification code.',
      invalidCredentials: 'Login credentials are incorrect.',
      invalidData: 'Invalid data. Please review your input.',
      sessionExpired: 'Your session has expired. Please log in again.',
      forbidden: 'You do not have permission to perform this action.',
      requestFailed: 'Unable to complete the request. Please try again.',
      roleRejectedTitle: 'Role upgrade request was rejected',
      roleApprovedTitle: 'Congratulations, your request was approved',
      roleRejectedBody: 'Your landlord/broker role upgrade request was rejected.',
      roleApprovedBody: 'Your landlord/broker role upgrade request was approved successfully.',
      adminReason: 'Admin reason',
      adminNote: 'Admin note',
    },
    roles: {
      admin: 'Administrator',
      landlord: 'Landlord',
      saler: 'Saler',
      user: 'Tenant',
    },
    dashboard: {
      greeting: 'Hello',
      role: 'Role',
      myRooms: 'My rooms',
      bookings: 'Bookings',
      manageUsers: 'Manage users',
      viewAll: 'View all',
      manage: 'Manage',
      recentBookings: 'Recent bookings',
      noBookings: 'No bookings yet',
      quickLinks: 'Quick links',
      findRooms: 'Find rooms',
      createRoom: 'Post new room',
      profile: 'Profile',
      room: 'Room',
      booker: 'Booker',
      startDate: 'Start date',
      status: 'Status',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      statusCompleted: 'Completed',
      dbInfo: 'Database info',
      usingDb: 'Using database',
      onHost: 'on host',
      environment: 'Environment',
      pendingRequests: 'landlord/broker requests are pending approval.',
      handleNow: 'Handle now',
    },
    roomList: {
      sortLatest: 'Newest',
      sortOldest: 'Oldest',
      sortPriceAsc: 'Price: Low → High',
      sortPriceDesc: 'Price: High → Low',
      sortCapacityAsc: 'Capacity: Low → High',
      sortCapacityDesc: 'Capacity: High → Low',
      amenityWifi: 'WiFi',
      amenityAc: 'Air conditioner',
      amenityKitchen: 'Kitchen',
      amenityParking: 'Parking',
      amenityWater: 'Hot water',
      amenitySecurity: '24/7 security',
      loadFailed: 'Unable to load room list. Please try again.',
      heroTitle: 'Discover rooms that match your real needs',
      loadingRooms: 'Loading room data...',
      heroSubtitle: 'Focus on location, price, and capacity so you can choose quickly and confidently.',
      statShowing: 'Rooms showing',
      statAvgPrice: 'Average price / month',
      statAvailable: 'Available rooms',
      viewMode: 'Room display mode',
      activeFilters: 'Active filters',
      sortBy: 'Sort by:',
      sortAria: 'Sort rooms',
      viewGrid: 'View as grid',
      viewList: 'View as list',
      viewMap: 'View as map',
      viewAllRooms: 'View all rooms',
      viewFavoriteRooms: 'View favorite rooms',
      enableInfiniteScroll: 'Enable infinite scroll',
      disableInfiniteScroll: 'Disable infinite scroll',
      infiniteOn: 'Infinite scroll: On',
      infiniteOff: 'Infinite scroll: Off',
      favorites: 'Favorites',
      searchPlaceholder: 'Search...',
      searchAgain: 'Search again',
      searchByTitle: 'Search by room title',
      openFilters: 'Open filters',
      closeFilters: 'Close filters',
      openSettings: 'Open display settings',
      products: 'Products',
      projects: 'Projects',
      statistics: 'Statistics',
      map: 'Map',
      favoriteFilters: 'Favorite filters',
      noFavoriteFilters: 'No saved filters',
      recentSearches: 'Recent searches',
      city: 'City',
      district: 'District',
      ward: 'Ward',
      street: 'Street',
      filterByCity: 'Filter by city',
      minPrice: 'Minimum price',
      maxPrice: 'Maximum price',
      minCommission: 'Minimum commission (%)',
      maxCommission: 'Maximum commission (%)',
      roomType: 'Room type',
      allRoomTypes: 'All room types',
      furnishing: 'Furnishing',
      allFurnishing: 'All furnishing',
      typeRoom: 'Room',
      typeGac: 'Loft',
      typeStudio: 'Studio',
      typeDuplex: 'Duplex',
      typeStudioSeparate: 'Studio with separate kitchen',
      typeOneBedroom: '1BR',
      typeTwoBedroom: '2BR',
      typeThreeBedroom: '3BR',
      typeApartment: 'Apartment',
      typeWholeHouse: 'Whole house',
      typeCommercial: 'Commercial',
      furnishingFull: 'Fully furnished',
      furnishingBasic: 'Basic furnishing',
      furnishingEmpty: 'Unfurnished',
      statusAndOffers: 'Status & offers',
      statusSoonAvailable: 'Available soon',
      statusTransfer: 'Transfer',
      statusClosed: 'Closed',
      statusReserved: 'Reserved',
      hotOffer: 'Hot bonus',
      exclusiveOffer: 'Exclusive',
      amenities: 'Amenities:',
      applyFilters: 'Apply search filters',
      search: 'Search',
      clearFilters: 'Clear filters',
      noResults: 'No results',
      results: 'results',
      clearSearchFilter: 'Clear search filter',
      clearCityFilter: 'Clear city filter',
      clearMinPriceFilter: 'Clear minimum price filter',
      clearMaxPriceFilter: 'Clear maximum price filter',
      minPricePrefix: 'Min',
      maxPricePrefix: 'Max',
      clearAmenity: 'Remove amenity',
      disableFavoriteFilter: 'Disable favorites filter',
      noFavoriteRooms: 'No favorite rooms yet',
      noRoomsFound: 'No rooms found',
      noFavoriteRoomsHint: 'Start adding favorites by pressing the heart button on room cards.',
      noRoomsFoundHint: 'Try changing your filters or searching with different criteria.',
      clearFiltersAndRetry: 'Clear filters and retry',
      loginForMore: 'Login to see more options',
      statusAvailable: 'Available',
      statusRented: 'Rented',
      statusMaintenance: 'Maintenance',
      detail: 'Detail',
      directions: 'Directions',
      area: 'Area',
      capacity: 'Capacity',
      person: 'person',
      prevImage: 'View previous image',
      nextImage: 'View next image',
      addFavoriteAria: 'Add {title} to favorites',
      removeFavoriteAria: 'Remove {title} from favorites',
      currencyShort: 'VND',
      perMonth: 'month',
      viewRoomDetail: 'View room detail',
      viewDetail: 'View detail',
      prevPage: 'Previous page',
      nextPage: 'Next page',
      page: 'Page',
      loadMoreRooms: 'Load more rooms',
      loadMore: 'Load more',
    },
    home: {
      heroTitle: 'A transparent rental platform that is easy to operate and ready to scale',
      heroSubtitle: 'From searching rooms by area, price, and amenities to managing bookings and landlords in one system, with a smooth experience on desktop and mobile.',
      ctaExploreRooms: 'Explore rooms',
      ctaStartPosting: 'Start posting',
      ctaGoDashboard: 'Go to dashboard',
      statUptime: 'System runs continuously',
      statOnePlatformTitle: 'One platform',
      statOnePlatformDesc: 'For tenants, landlords, and admins',
      statRealtime: 'Realtime booking status updates',
      statScalable: 'Built for large-scale growth',
      featureTitle: 'Core features',
      featureSubtitle: 'Focused on practical workflows in the rental industry.',
      featureSearchTitle: 'Find rooms by real needs',
      featureSearchDesc: 'Filters by city, price range, and room status help renters decide faster.',
      featureManageTitle: 'Centralized listing management',
      featureManageDesc: 'Landlords and brokers track posted rooms, availability, and transaction history in one place.',
      featureDashboardTitle: 'Operationally clear dashboard',
      featureDashboardDesc: 'Monitor bookings, users, and rooms with a clear interface for scale operations.',
    },
    myRooms: {
      title: 'My rooms',
      createNew: 'Create new listing',
      createFirst: 'Create your first listing',
      emptyTitle: 'You have not posted any rooms yet',
      emptyDescription: 'Start generating revenue by posting your room on the platform.',
      colTitle: 'Title',
      colAddress: 'Address',
      colPrice: 'Price',
      colStatus: 'Status',
      colActions: 'Actions',
      statusAvailable: 'Available',
      statusRented: 'Rented',
      statusMaintenance: 'Maintenance',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      viewAria: 'View room detail {title}',
      editAria: 'Edit room {title}',
      deleteAria: 'Delete room {title}',
      confirmDelete: 'Are you sure you want to delete this room?',
      deleteFailed: 'Failed to delete room',
      copyId: 'Copy room ID',
      quickStatus: 'Quick room status change',
      activateRoom: 'Activate: available and publicly visible',
      deactivateRoom: 'Deactivate: unavailable and hidden publicly',
      updatingStatus: 'Saving...',
      roomActivated: 'Room is available and publicly visible.',
      roomHidden: 'Room is unavailable and hidden publicly.',
      statusUpdateFailed: 'Unable to update room status. Please try again.',
      idCopied: 'Room ID copied',
      copyIdFailed: 'Unable to copy. Please select the room ID and copy it manually.',
      currencyShort: 'VND',
    },
    bookingList: {
      title: 'Booking list',
      updateFailed: 'Failed to update booking status',
      confirmCancel: 'Delete this deposit receipt? It will be removed from the system.',
      cancelTitle: 'Delete deposit receipt',
      draftDeleteTitle: 'Delete draft',
      draftDeleteMessage: 'Delete this deposit draft? Its information and attachments will be removed.',
      draftDelete: 'Delete draft',
      draftKeep: 'Keep draft',
      edit: 'Edit',
      openingEditor: 'Opening…',
      editFailed: 'Unable to open this deposit receipt for editing. Please try again.',
      deleteFailed: 'Failed to delete booking',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      statusCompleted: 'Completed',
      infoLabel: 'Info',
      emptyTitle: 'No bookings found',
      emptyManager: 'There are no booking requests yet. Requests will appear here.',
      emptyUser: 'You have not booked any room yet. Explore available rooms.',
      colRoom: 'Room',
      colBooker: 'Booker',
      colStartDate: 'Start date',
      colPrice: 'Price',
      colStatus: 'Status',
      colActions: 'Actions',
      approve: 'Approve',
      reject: 'Reject',
      complete: 'Complete',
      cancel: 'Delete receipt',
      viewForm: 'View form',
      approveAria: 'Approve booking {id}',
      rejectAria: 'Reject booking {id}',
      completeAria: 'Complete booking {id}',
      cancelAria: 'Delete deposit receipt {id}',
      viewFormAria: 'View customer form for booking {id}',
      modalTitle: 'Submitted customer information',
      closeModal: 'Close booking details',
      orderLabel: 'Order',
      roomLabel: 'Room',
      bookerLabel: 'Booker',
      currencyShort: 'VND',
    },
    createRoom: {
      title: 'Create new room listing',
      maxImagesError: 'You can select up to {max} images only.',
      maxImageSizeError: 'Each image must be at most {size}MB.',
      readImageFailed: 'Failed to read image files. Please reselect images.',
      createSuccessWithId: 'Room created successfully: {title} (ID: {id})',
      createSuccess: 'Room created successfully.',
      invalidData: 'Invalid data. Please review your input.',
      sessionExpired: 'Your session has expired. Please log in again.',
      noPermission: 'You do not have permission to create a room.',
      imageTooLarge: 'Image size is too large. Please reduce image size.',
      createFailed: 'Failed to create room. Please try again.',
      fieldTitle: 'Title',
      fieldDescription: 'Description',
      fieldAddress: 'Address',
      fieldDistrict: 'District',
      fieldCity: 'City',
      mapTitle: 'Select room location on map',
      mapHint: 'Click directly on the map to place a pin. Drag the pin to adjust to an exact position.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      notSelected: 'Not selected',
      fieldPrice: 'Price ({currency}/{period})',
      perMonth: 'month',
      fieldArea: 'Room area (m²)',
      fieldCapacity: 'Capacity (person)',
      fieldUtilities: 'Utilities (comma separated)',
      utilitiesPlaceholder: 'Example: Wifi, Air conditioner, Refrigerator, Washing machine',
      fieldImages: 'Room images (up to {max} images, each <= {size}MB)',
      selectedCount: 'Selected: {count} images',
      removeSelectedImageAria: 'Remove selected image {index}',
      creating: 'Creating...',
      submit: 'Create room',
    },
    editRoom: {
      title: 'Edit room listing',
      loadFailed: 'Unable to load room information',
      maxImagesExceeded: 'You can select up to {max} images only.',
      imageSizeLimitExceeded: 'Each image must be at most {size}MB.',
      readImageFailed: 'Failed to read image files. Please reselect images.',
      invalidData: 'Invalid data. Please review your input.',
      updateSuccess: 'Room updated successfully.',
      updateFailed: 'Failed to update room. Please try again.',
      sessionExpired: 'Your session has expired. Please log in again.',
      noPermission: 'You do not have permission to edit this room.',
      fieldTitle: 'Title',
      fieldDescription: 'Description',
      fieldAddress: 'Address',
      fieldDistrict: 'District',
      fieldCity: 'City',
      mapTitle: 'Select room location on map',
      mapHint: 'Click directly on the map to place a pin. Drag the pin to adjust to an exact position.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      notSelected: 'Not selected',
      fieldPrice: 'Price ({currency}/{period})',
      perMonth: 'month',
      fieldArea: 'Room area (m²)',
      fieldCapacity: 'Capacity (person)',
      fieldStatus: 'Status',
      statusAvailable: 'Available',
      statusRented: 'Rented',
      statusMaintenance: 'Maintenance',
      fieldUtilities: 'Utilities (comma separated)',
      utilitiesPlaceholder: 'Example: Wifi, Air conditioner, Refrigerator, Washing machine',
      existingImages: 'Current images',
      roomImageAlt: 'Room image {index}',
      noImages: 'No images yet',
      addNewImages: 'Add new images (up to {max} images, each <= {size}MB)',
      newImageAlt: 'New room image {index}',
      updating: 'Updating...',
      submit: 'Update',
    },
    roomDetail: {
      title: 'Room details',
      loading: 'Loading...',
      notFound: 'Room not found',
      back: '← Back',
      statusAvailable: 'Available',
      statusRented: 'Rented',
      statusMaintenance: 'Maintenance',
      share: 'Share',
      copyLink: 'Copy link',
      shareSuccessMessage: 'Copied share link.',
      shareErrorMessage: 'Unable to share at this time.',
      copiedMessage: 'Copied.',
      copyErrorMessage: 'Unable to copy at this time.',
      shareAria: 'Share room',
      copyLinkAria: 'Copy room link',
      areaLabel: 'Room area',
      capacityLabel: 'Capacity',
      person: 'person',
      addressLabel: 'Address',
      prevImageAria: 'View previous image',
      nextImageAria: 'View next image',
      noImages: 'No images available for this room',
      scrollLeftAria: 'Scroll thumbnails left',
      scrollRightAria: 'Scroll thumbnails right',
      selectImageAria: 'Select image {index}',
      detailDescription: 'Detailed description',
      detailAddress: 'Address',
      detailAddressValue: 'Address:',
      detailWard: 'Ward:',
      detailDistrict: 'District:',
      detailCity: 'City:',
      roomInformation: 'Room information',
      roomType: 'Room type',
      furnishing: 'Furnishing',
      notAvailable: 'Not updated',
      fees: 'Fees',
      electricity: 'Electricity',
      water: 'Water',
      parking: 'Parking',
      serviceFee: 'Service fee',
      otherFee: 'Other fee',
      policies: 'Policies & rules',
      depositMonths: 'Deposit',
      reservationFee: 'Reservation deposit',
      additionalDeposit: 'Additional amount',
      contractMonths: 'Contract term',
      holdDays: 'Room hold period',
      maxVehicles: 'Maximum vehicles',
      pets: 'Pets',
      foreignGuests: 'Foreign guests',
      mapLocation: 'Location on map',
      directions: 'Directions',
      coordinates: 'Coordinates:',
      utilities: 'Utilities',
      currencySymbol: 'VND/month',
      ownerInfo: 'Owner information',
      ownerName: 'Name:',
      ownerPhone: 'Phone:',
      phoneNotUpdated: 'Not updated',
      callNow: 'Call now',
      copyNumber: 'Copy number',
      sendZalo: 'Send Zalo',
      openMessenger: 'Open Messenger',
      openFacebook: 'Facebook',
      qrTitle: 'QR Zalo',
      bookingTitle: 'Book room',
      bookingLoginMessage: 'Please log in to book this room',
      bookingLogin: 'Login',
      bookingRegisterHint: "Don't have an account?",
      bookingRegisterLink: 'Register now',
      bookingButton: 'Book now',
      bookingModalTitle: 'Booking information',
      bookingModalClose: 'Close booking form',
      bookingStartDate: 'Start date',
      bookingMonths: 'Rental months',
      bookingEndDate: 'Auto-calculated end date',
      bookingEndDateAuto: 'Auto-calculated',
      bookingFullName: 'Full name',
      bookingPhone: 'Phone number',
      bookingAddress: 'Permanent address',
      bookingCCCD: 'ID number',
      bookingPeople: 'Number of people',
      bookingVehicles: 'Number of vehicles',
      bookingNotes: 'Notes',
      bookingNotesPlaceholder: 'Add notes if any...',
      bookingSubmit: 'Complete',
      bookingRequired: 'Please fill in all required information.',
      bookingInvalidPeople: 'Number of people must be at least 1.',
      bookingInvalidVehicles: 'Number of vehicles is invalid.',
      bookingInvalidMonths: 'Rental months must be between 1 and 120.',
      bookingInvalidDate: 'Start date is invalid.',
      bookingPastDate: 'Start date must be today or later.',
      bookingSuccess: 'Booking successful! Please wait for approval.',
      bookingFailed: 'Booking failed. Please try again.',
      edit: 'Edit',
      buildingNotesStartDate: 'Start date',
      buildingNotesMonths: 'Rental months',
      buildingNotesEndDate: 'End date',
      buildingNotesFullName: 'Full name',
      buildingNotesPhone: 'Phone',
      buildingNotesAddress: 'Address',
      buildingNotesCCCD: 'ID',
      buildingNotesPeople: 'People',
      buildingNotesVehicles: 'Vehicles',
      buildingNotesNotes: 'Notes',
    },
    userList: {
      title: 'User Management',
      noUsers: 'No users found',
        notAvailable: 'N/A',
      onlyAdmin: 'You are currently the only administrator in the system.',
      requestsTitle: 'Landlord/Broker registration requests',
      noRequests: 'No requests found.',
      id: 'ID',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      phone: 'Phone',
      createdAt: 'Created at',
      actions: 'Actions',
      identifier: 'Identifier',
      userNote: 'User note',
      status: 'Status',
      approve: 'Approve',
      reject: 'Reject',
      processed: 'Processed',
      notUpdated: 'Not updated',
      delete: 'Delete',
        deleteUserAria: 'Delete user {name}',
      grantSaler: 'Grant landlord role',
      revokeSaler: 'Remove landlord role',
      confirmDeleteTitle: 'Confirm account deletion',
      confirmRoleTitle: 'Confirm role update',
      confirmRoleChange: 'Change {name} to the {role} role?',
      roleFor: 'Role for {name}',
      confirmDeleteMessage: 'Are you sure you want to delete account {name}?',
      confirmGrantRole: 'Are you sure you want to grant Landlord/Broker role to {name}?',
      confirmRevokeRole: 'Are you sure you want to revoke Landlord/Broker role (back to Tenant) for {name}?',
      deleteSuccess: 'Account deleted successfully.',
      updateRoleSuccess: 'User role updated successfully.',
      actionFailed: 'Unable to complete this action.',
      reviewFailed: 'Failed to process request.',
      approvedSuccess: 'Request approved.',
      rejectedSuccess: 'Request rejected.',
      approveNote: 'Approval note (optional)',
      rejectNote: 'Rejection reason (optional)',
      inputNote: 'Enter note...',
      approveRequest: 'Approve request',
      rejectRequest: 'Confirm rejection',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    profile: {
      userCode: 'User code',
      userCodePending: 'Assigned when the account upgrade is approved',
      userCodeHint: 'This code is assigned automatically and cannot be changed.',
      title: 'Profile',
      updateSuccess: 'Profile updated successfully!',
      updateFailed: 'Profile update failed. Please try again.',
      role: 'Role',
      address: 'Address',
      changePassword: 'Change password',
      leaveEmpty: 'Leave blank if you do not want to change your password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      updateProfile: 'Update profile',
      updating: 'Updating...',
      ownerRegisterTitle: 'Register as Landlord / Broker',
      ownerRegisterButton: 'Register as Landlord / Broker',
      ownerRegisterClose: 'Close registration form',
      ownerPending: 'You already have a pending request and cannot submit another now.',
      ownerHint: 'Fill in this form for admin review. If approved, your account will be upgraded to landlord/broker.',
      companyName: 'Business / brand name (optional)',
      idNumber: 'National ID / identity number',
      expYears: 'Years of experience',
      propertyCount: 'Number of rooms/properties managed',
      extraInfo: 'Additional information',
      extraInfoPlaceholder: 'Example: operating areas, years in business...',
      submitRequest: 'Submit request for approval',
      submittingRequest: 'Submitting request...',
      requestFailed: 'Unable to submit request. Please try again.',
      requestSent: 'Landlord/broker registration request submitted.',
    },
  },
};

const LanguageContext = createContext({
  language: 'vi',
  setLanguage: () => {},
  t: (key, replacements) => key,
});

const resolveTranslation = (lang, key) => {
  const segments = key.split('.');
  let value = translations[lang];

  for (const segment of segments) {
    value = value?.[segment];
    if (typeof value === 'undefined') {
      return null;
    }
  }

  return typeof value === 'string' ? value : null;
};

const applyReplacements = (text, replacements) => {
  if (!replacements) {
    return text;
  }

  return Object.keys(replacements).reduce((acc, key) => {
    return acc.replaceAll(`{${key}}`, String(replacements[key]));
  }, text);
};

const apiMessageMap = {
  'The provided credentials are incorrect.': 'auth.invalidCredentials',
  'The given data was invalid.': 'auth.invalidData',
  'Unauthenticated.': 'auth.sessionExpired',
  'Unauthorized.': 'auth.forbidden',
  'Forbidden.': 'auth.forbidden',
  'Request failed.': 'auth.requestFailed',
};

export const translateApiMessage = (t, message, fallbackKey) => {
  const rawMessage = String(message || '').trim();

  if (!rawMessage) {
    return fallbackKey ? t(fallbackKey) : '';
  }

  const translatedKey = apiMessageMap[rawMessage];
  if (translatedKey) {
    return t(translatedKey);
  }

  return rawMessage || (fallbackKey ? t(fallbackKey) : '');
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'vi');

  const value = useMemo(() => ({
    language,
    setLanguage: (next) => {
      localStorage.setItem('language', next);
      setLanguage(next);
    },
    t: (key, replacements) => {
      const result = resolveTranslation(language, key)
        ?? resolveTranslation('vi', key)
        ?? key;
      return applyReplacements(result, replacements);
    },
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
